import { render, staticRenderFns } from "./VisualDataSection.vue?vue&type=template&id=2dc2878c&"
import script from "./VisualDataSection.vue?vue&type=script&lang=js&"
export * from "./VisualDataSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports